const checkAppVersion = async () => {
  try {
    if (window.location.hostname === 'localhost') {
      return // Skip version check on localhost
    }

    const response = await fetch(`/version.json?cb=${Date.now()}`, { cache: 'no-cache' })
    const responseData = await response.json()
    const deployedVersion = responseData?.version
    const currentVersion = process.env.VUE_APP_VERSION

    if (deployedVersion !== currentVersion) {
      if ('caches' in window) {
        const cacheNames = await caches.keys()
        await Promise.all(cacheNames.map((name) => caches.delete(name)))
      }

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        for (const registration of registrations) {
          await registration.unregister()
        }
      }

      window.location.reload()
    }
  } catch (e) {
    console.error('Error checking app version:', e)
  }
}

export default checkAppVersion
